import type { App } from 'vue'
import { colors } from '@unocss/preset-mini'
import { createVuetify, type VuetifyOptions } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import * as labsComponents from 'vuetify/labs/components'

import { ru } from 'vuetify/locale'
import '@/assets/styles/main.css'
import '@/assets/styles/vue-flow.css'
import 'vuetify/styles'
import '@mdi/font/css/materialdesignicons.css'
import 'uno.css'

/**
 * Vuetify Components
 *
 * @see {@link https://vuetifyjs.com/en/features/treeshaking/}
 */
let vuetifyConfig: VuetifyOptions = {
  // Internationalization (i18n)
  // https://vuetifyjs.com/en/features/internationalization/#internationalization-i18n
  locale: {
    locale: 'ru',
    fallback: 'ru',
    messages: { ru },
  },
  // Theme
  // https://vuetifyjs.com/en/features/theme/
  theme: {
    defaultTheme: 'light',
    themes: {
      light: {
        colors: {
          primary: colors.blue[700],
          secondary: colors.gray[600],
          accent: colors.black,
          info: colors.blue[400],
          warning: colors.amber[600],
          error: colors.red[600],
          success: colors.green[600],
          help: colors.purple[600],
          gray: colors.gray[200],
        },
      },
      dark: {
        colors: {
          primary: colors.blue[700],
          secondary: colors.gray[600],
          accent: colors.black,
          info: colors.blue[400],
          warning: colors.amber[600],
          error: colors.red[600],
          success: colors.green[600],
          help: colors.purple[600],
          gray: colors.gray[200],
          surface: colors.gray[600],
        },
      },
    },
  },
}

if (import.meta.env.DEV) {
  // Disable treeshaking for DEV mode.
  vuetifyConfig = {
    components: { components, labsComponents },
    directives,
    ...vuetifyConfig,
  }
}
export const Vuetify = createVuetify(vuetifyConfig)

export function initVuetify(app: App<Element>) {
  app.use(Vuetify)
}
